export default __webpack_public_path__ + "static/media/44.860f2e25.jpg";